<template>
  <div class="customer-create">
    <PageHeader title="Add Customer" />

    <div class="card">
      <CustomerForm
        :model="customer"
        :save-function="createCustomer"
        @cancel="$router.push({ name: 'ListCustomers' })"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import PageHeader from '@/components/app/AppPageHeader.vue'
import CustomerForm from '@/modules/Customer/components/CustomerForm.vue'
import { ref } from 'vue'
import { Customer } from '@/models/customer'
import CustomerService from '@/services/CustomerService'
import { useRouter } from 'vue-router'
import { useNotification } from '@kyvg/vue3-notification'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

useHead({ title: 'Add Customer' })

const customer = ref(new Customer())
const customerService = new CustomerService()
const $router = useRouter()
const { notify } = useNotification()
const queryClient = useQueryClient()

const { mutateAsync: createCustomer } = useMutation({
  mutationFn: (newCustomer: Customer) => customerService.create(newCustomer),
  onSuccess: (newCustomer: Customer) => {
    if (newCustomer.isCompany) {
      notify({
        type: 'success',
        title: 'Company created',
        text: 'Company created successfully'
      })
    } else {
      notify({
        type: 'success',
        title: 'Customer created',
        text: 'Customer created successfully'
      })
    }
    queryClient.setQueryData(['customer', newCustomer.id], newCustomer)
    queryClient.invalidateQueries({ queryKey: ['customers'] })
    $router.push({ name: 'ShowCustomer', params: { id: newCustomer.id } })
  },
  onError: (error) => {
    notify({
      type: 'error',
      title: 'Error',
      text: error.message || 'An error occurred while trying to create the customer'
    })
  }
})
</script>
